module.exports = __webpack_public_path__ + "static/media/CSVIcon.b86739bd.svg";